<template>
<header class="">
        <div id="top_line">
            <div class="container">
                <div class="row">
                    <div class="col-9"><i class="icon-phone"></i><strong>021-44631360-5 </strong></div>
                    <div class="col-3">
                       
                          <a style="font-size:12px;color:white"  href="support@dariushgroup.com" >support@dariushgroup.com</a>
                       
                       
                    </div>
                </div><!-- End row -->
            </div><!-- End container-->
        </div><!-- End top line-->
        
        <div class="container">
            
            <div class="row">
                <div class="col-3">
                    <div id="logo_home">
                    	<h1><a @click="goToHome" title="City tours travel template">رزرواسیون پردیس داریوش کیش</a></h1>
                    </div>
                </div>
                <nav  class=".menu-list col-9">
                    <a class="cmn-toggle-switch cmn-toggle-switch__htx open_close" href="javascript:void(0);"><span>Menu mobile</span></a>
                    <div class="main-menu">
                        <div id="header_menu">
                            <img src="img/logo_sticky.png" width="160" height="34" alt="City tours">
                        </div>
                        <a href="#" class="open_close" id="close_in"><i class="icon_set_1_icon-77"></i></a>
                       <ul>
                            <li class="submenu">
                               <a href="javascript:void(0);"  @click="goToHome()" > صفحه نخست </a>
                            </li>
                            <li class="submenu">
                               <a href="javascript:void(0);"  @click="goToHome()" >هتل </a>
                            
                            </li>
                               <li class="submenu">
                                  <a href="javascript:void(0);"  @click="goToHome()" >هتل + پرواز </a>
                            </li>
                             <!-- <li class="submenu">
                               <a style="cursor: pointer" href="https://dp.dariushgroup.com/" target="_blank">پارک دلفین ها</a>
                            </li> -->
                            <li class="submenu">
                               <router-link  to="/tourism/tourismSearch/fasttrack" >فست ترک فرودگاه امام خمینی</router-link>
                            </li>
                              <li class="submenu">
                               <a href="https://dariushgroup.com/HELP/%D8%B1%D8%A7%D9%87%D9%86%D9%85%D8%A7%DB%8C%20%D9%87%D8%AA%D9%84%20%D9%BE%D8%B1%D9%88%D8%A7%D8%B2.pdf" target="_blank">راهنما </a>
                            </li>
                       
                       
                        </ul>
                    </div><!-- End main-menu -->
                 
                </nav>
            </div>
        </div><!-- container -->
    </header>
</template>


<script>
import $ from "jquery";

export default {
  name: "PdkHeader",
  data() {
    return {
      tabIndex: 0,
      topline: [],
      isLoading: false,
    };
  },
  components: {},
  computed: {},
  mounted: function () {
    /* Sticky nav */
    $(window).scroll(function () {
      "use strict";
      if ($(this).scrollTop() > 1) {
        $("header").addClass("sticky");
      } else {
        $("header").removeClass("sticky");
      }
    });

    /* Menu */
    $("a.open_close").on("click", function () {
      $(".main-menu").toggleClass("show");
      $(".layer").toggleClass("layer-is-visible");
    });

    $("a.show-submenu").on("click", function () {
      $(this).next().toggleClass("show_normal");
    });

    $("a.show-submenu-mega").on("click", function () {
      $(this).next().toggleClass("show_mega");
    });

    if ($(window).width() <= 550) {
      $("a.open_close").on("click", function () {
        $(".cmn-toggle-switch").removeClass("active");
      });
    }
  },
  created() {},

  methods: {
    goToHome() {
      if (this.$route.name != "main home")
        this.$router.push({
          path: "",
          name: "main home",
        });
    },
  },
};
</script>
<style lang="css" scoped>
.close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.5;
}

button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert h4 {
  margin-top: 0;
  color: inherit;
}

.alert .alert-link {
  font-weight: bold;
}

.alert > p,
.alert > ul {
  margin-bottom: 0;
}

.alert > p + p {
  margin-top: 5px;
}

.alert-dismissable {
  padding-right: 35px;
}

.alert-dismissable .close {
  position: relative;
  top: -2px;
  right: -21px;
  color: inherit;
}

.alert-danger {
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
}

.alert-danger hr {
  border-top-color: #e4b9c0;
}

.alert-danger .alert-link {
  color: #843534;
}

.alert {
  border-radius: 0;
  -webkit-border-radius: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.11);
}

.alert-danger {
  background-color: #f2dede;
  border-color: #e0b1b8;
  color: #b94a48;
}

.alert-white {
  background-image: linear-gradient(to bottom, #ffffff, #f5f7f9);
  border-top-color: #d8d8d8;
  border-bottom-color: #bdbdbd;
  border-left-color: #cacaca;
  border-right-color: #cacaca;
  color: #404040;
  padding-left: 61px;
  position: relative;
}

.alert-white .icon {
  text-align: center;
  width: 45px;
  height: 100%;
  position: absolute;
  top: -1px;
  left: -1px;
  border: 1px solid #bdbdbd;
}

.alert-white .icon:after {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  display: block;
  content: "";
  width: 10px;
  height: 10px;
  border: 1px solid #bdbdbd;
  position: absolute;
  border-left: 0;
  border-bottom: 0;
  top: 50%;
  right: -6px;
  margin-top: -5px;
  background: #fff;
}

.alert-white.rounded {
  border-radius: 3px;
  -webkit-border-radius: 3px;
}

.alert-white.rounded .icon {
  border-radius: 3px 0 0 3px;
  -webkit-border-radius: 3px 0 0 3px;
}

.alert-white .icon i {
  font-size: 20px;
  color: #fff;
  left: 12px;
  margin-top: -10px;
  position: absolute;
  top: 50%;
}

.alert-white.alert-danger .icon,
.alert-white.alert-danger .icon:after {
  border-color: #ca452e;
  background: #da4932;
}

.show-mobile-menu {
  display: none;
}
.show-menu {
  display: block;
}

.profile-alert {
  display: none;
  margin: 20px 0px 0px 0px;
}
@media only screen and (max-width: 750px) {
  .menu-list {
    display: none !important;
  }
 
}

.main {
  margin-right: 10px;
  position: relative;
  text-align: right;
}
label {
  width: 100%;
  position: absolute;
  line-height: 45px;
  top: 0px;
  left: 0px;
  background-color: #fff;
  padding-left: 20px;
  font-weight: 700;
  -webkit-transition: 0.04s ease-in-out;
  transition: 0.04s ease-in-out;
}
.list {
  box-shadow: -5px 5px 5px -5px #333;
  width: 100%;
  position: absolute;
  z-index: 1;
  top: 45px;
  left: 0px;
  border-top: 1px solid #eee;
  visibility: hidden;
  opacity: 0;
  cursor: pointer;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
.item {
  min-width: 250px;
  width: 100%;
  line-height: 45px;
  padding-right: 20px;
  background-color: #fff;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
  font-weight: 400;
}
.item:hover {
  background-color: #eee;
}

/**********
***********/

#drop-1:checked ~ .list-1 {
  visibility: visible;
  opacity: 2;
  z-index: 10;
}

a:hover {
  color: #d5ab3d;
}
a {
  font-size: 15px;
}
.custom-menu {
  padding-right: 0px;
  padding-left: 20px;
}
.router-link-exact-active {
    color: #bf8604 !important;
    border-radius: 25px !important;
    padding-top: 10px !important;
}
</style>